import React from "react";
import { useTranslation } from "react-i18next";
const Image_1 = "../assets/img/Loading.png";
const BrokenImage = '../assets/img/not_found.png'

export default function EducationAfterWorkPhotoModal({ setshowWorkImagePopup, AfterWorkPhotoData, workPhotoData, setipost, ispost, Heading }) {

    const { t } = useTranslation()

    console.log("Heading", Heading)

    const imageOnLoad = (event) => {
        console.log(event)
        console.log(`Picture successfully ${event.currentTarget.src} loaded.`);
        if (event.currentTarget.className !== "error") {
            event.currentTarget.className = "success";
        }
    };
    const imageOnError = (event) => {
        event.currentTarget.src = BrokenImage;
        event.currentTarget.className = "error";
    };

    return (
        <>
            <div className=" modal show fade" style={{ display: "block", backgroundColor: "#00000055", overflow: 'auto' }} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered mt-5" role="document">
                    <div className="modal-content" id='nested'>
                        <div className="modal-header popheding" id="popupheading">
                            <div className=" ml-4">
                                <span style={{ fontSize: '19px', fontWeight: 'bold' }}> {t('Dashboard.Work_Assigned_by_Officials.Work_Name')} - {Heading?.workname}</span>
                            </div>

                            <button type="button" className="btn-close mr-3 mt-1" data-dismiss="modal" aria-label="Close" data-backdrop='static'
                                style={{ color: 'white' }}
                                onClick={() => {
                                    setshowWorkImagePopup(false)
                                }}>
                           </button>
                        </div>
                        <div className="row modal-body pt-0" >
                            <div className="col-6 modal-header justify-content-center border-end " >
                              

                                <div className=" fs-6 fw-bold text-danger">
                                    {t('AdminDashboard.Admin_Sidebar_Table_Heading.Before_Work_Photo')}
                                    <span className="d-flex justify-content-center pt-3">
                                        {
                                            workPhotoData ?
                                                <img className="col-12" style={{ width: "400px", height: "400px" }} src={workPhotoData == null ? "ImageNotFound" : workPhotoData}
                                                    onLoad={imageOnLoad} onError={imageOnError} />
                                                : <img src="../assets/img/not_found.png" />
                                        }
                                    </span>

                                </div>
                              
                            </div>
                            <div className="col-6 modal-header justify-content-center" >
                                <div className="fs-6 fw-bold text-danger">
                                    {t('AdminDashboard.Admin_Sidebar_Table_Heading.After_Work_Photo')}
                                    <span className="d-flex justify-content-center pt-3">
                                        {
                                            AfterWorkPhotoData ?
                                                <img className="col-12" style={{ width: "400px", height: "400px" }} src={AfterWorkPhotoData == null ? "ImageNotFound" : AfterWorkPhotoData}
                                                    onLoad={imageOnLoad} onError={imageOnError} />
                                                : <img src="../assets/img/not_found.png" />
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


